export function createMockSlipRow(overrides = {}) {
    return {
        id: '83b6277f-fb75-4f7f-86b2-912daab16508',
        duedate: '2025-06-25T12:03:55.913Z',
        amount: 23.23,
        debitor: {
            name: 'Leo CPF ACCOUNTANT dois',
            document: '12558778048',
            address: {
                postalCode: '01001000',
                number: '186',
                neighborhood: 'centro',
                city: 'porto alegre',
                state: 'RS',
            },
        },
        receiver: {
            name: 'Leo CPF ACCOUNTANT dois',
            document: '12558778048',
            account: '44537',
        },
        status: 8,
        statusText: 'PENDING_PAYMENT',
        barcode: '50991112300000023230000000003000000000173015',
        coreBankId: '511f53f3-0adb-4b42-ba57-6007a357bbc9',
        message: null,
        pixKey: 'testleo123@mailinator.com',
        pixEmv: '00020101021226980014br.gov.bcb.pix2576qrcode-h.pix.celcoin.com.br/pixqrcode/v2/cobv/406639e237a06bea9609f8369c4b775204000053039865802BR5923Leo CPF ACCOUNTANT dois6012porto alegre62070503***6304F187',
        bankNumber: '3000000000173015',
        bankAccount: '44537',
        bankEmissor: 'CELCOIN INSTITUIÇÃO DE PAGAMENTO - SA',
        bankLine: '50990000010000300000700001730159111230000002323',
        bankAgency: '0001',
        bankAssignor: 'CELCOIN INSTITUIÇÃO DE PAGAMENTO - SA',
        createAt: '2025-06-20T12:03:56.280Z',
        canceledCorebankData: null,
        interest: null,
        discountLimitDate: null,
        fine: null,
        discountModality: null,
        discountAmount: null,
        parentId: null,
        transactionId: null,
        paymentAccountId: null,
        email: null,
        cellphone: null,
        pixKeyType: null,
        txId: null,
        lineId: null,
        type: 3,
        payeeName: 'Leo CPF ACCOUNTANT dois',
        payeeTaxIdentifier: '12558778048',
        address: 'Rua do cliente,  186,  centro,  porto alegre-RS-',
        zipCode: '01001000',
        nossoNumero: '3000000000173015',
        registeredCorebankData: null,
        notificationType: null,
        tenantId: null,
        paidCorebankData: null,
        ...overrides,
    };
}
export const mockPaidSlipRow = createMockSlipRow({
    id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    duedate: '2025-07-10T10:00:00.000Z',
    amount: 150.5,
    debitor: {
        name: 'Maria Silva',
        document: '98765432100',
        address: {
            postalCode: '02002000',
            number: '100',
            neighborhood: 'bairro novo',
            city: 'são paulo',
            state: 'SP',
        },
    },
    receiver: {
        name: 'Empresa XYZ',
        document: '12345678000199',
        account: '12345',
    },
    status: 2,
    statusText: 'PAID',
    barcode: '12345678901234567890123456789012345678901234567890',
    coreBankId: 'abcdef12-3456-7890-abcd-ef1234567890',
    pixKey: 'maria.silva@mail.com',
    pixEmv: null,
    bankNumber: '1234567890',
    bankAccount: '12345',
    bankEmissor: 'BANCO DO BRASIL',
    bankLine: '1234567890123456789012345678901234567890',
    bankAgency: '0002',
    bankAssignor: 'BANCO DO BRASIL',
    createAt: '2025-07-01T09:00:00.000Z',
    payeeName: 'Maria Silva',
    payeeTaxIdentifier: '98765432100',
    address: 'Rua Nova, 100, bairro novo, são paulo-SP-',
    zipCode: '02002000',
    nossoNumero: '12345678901234567890',
});
export const mockPendingSlipRow = createMockSlipRow({
    id: 'b2c3d4e5-f6a1-7890-abcd-ef1234567890',
    duedate: '2025-08-15T15:30:00.000Z',
    amount: 75.0,
    debitor: {
        name: 'João Souza',
        document: '11223344556',
        address: {
            postalCode: '03003000',
            number: '50',
            neighborhood: 'centro',
            city: 'rio de janeiro',
            state: 'RJ',
        },
    },
    receiver: {
        name: 'Empresa ABC',
        document: '99887766554433',
        account: '54321',
    },
    status: 8,
    statusText: 'PENDING_PAYMENT',
    barcode: '9876543210987654321098765432109876543210',
    coreBankId: 'fedcba98-7654-3210-abcd-ef1234567890',
    pixKey: 'joao.souza@mail.com',
    pixEmv: null,
    bankNumber: '9876543210',
    bankAccount: '54321',
    bankEmissor: 'ITAÚ UNIBANCO',
    bankLine: '9876543210987654321098765432109876543210',
    bankAgency: '0003',
    bankAssignor: 'ITAÚ UNIBANCO',
    createAt: '2025-08-01T14:00:00.000Z',
    payeeName: 'João Souza',
    payeeTaxIdentifier: '11223344556',
    address: 'Av. Central, 50, centro, rio de janeiro-RJ-',
    zipCode: '03003000',
    nossoNumero: '98765432109876543210',
});
export const mockSlipListRows = [
    createMockSlipRow(),
    mockPaidSlipRow,
    mockPendingSlipRow,
];
export function createMockSlipListResponse(overrides = {}) {
    const rows = overrides.rows ?? mockSlipListRows;
    return {
        status: overrides.status ?? 200,
        result: {
            rows,
            count: overrides.count ?? rows.length,
            page: overrides.page ?? '1',
            pages: overrides.pages ?? 1,
        },
    };
}
export const mockEmptySlipListResponse = createMockSlipListResponse({
    rows: [],
    count: 0,
});
export function createMockApiState(data) {
    return {
        data: data === null ? undefined : (data ?? createMockSlipListResponse()),
        isLoading: false,
        isFetching: false,
        error: null,
    };
}
export const mockLoadingApiState = {
    data: undefined,
    isLoading: true,
    isFetching: false,
    error: null,
};
export function createMockErrorApiState(errorMessage) {
    return {
        data: undefined,
        isLoading: false,
        isFetching: false,
        error: errorMessage,
    };
}
